import { Typography } from "@mui/material"

export function RateCardHeaderLabel({ children, align }) {
    return (
        <Typography variant="subtitle2" color="text.secondary" align={align}>
            {children}
        </Typography>
    )
}
